import React, { useEffect, useState } from 'react';
import { Button, Checkbox, ColorPicker, DatePicker, Form, Input, Select, Switch, Tabs, Tooltip } from 'antd';
import { FloatingLabel } from 'flowbite-react';
import { Link, useLoaderData, useNavigate, useOutletContext, useParams } from 'react-router-dom';
import { FaCloudArrowUp } from 'react-icons/fa6';
import EventEmitter from '../../utils/eventEmitter';
import useJobPositionAPI from '../apis/JobPositionAPI';




const JobPositionChanges = () => {
  const [form] = Form.useForm();
  const { success, error } = useOutletContext();
  const {jobPosition} = useLoaderData();
  const params = useParams();
  const navigate = useNavigate();
  const [name, setName] = useState(jobPosition.name ? jobPosition.name : '');
  const { create, update } = useJobPositionAPI();


  const onChangeName = e => setName(e.target.value);

  const handleSubmit = async() => {
    let data = form.getFieldsValue();
    data['name'] = name;
    data['seo'] = name.replace(/ /g, '-').toLowerCase();
    create(data, success);
    // console.log(data.color.toHexString())
    console.log(data)
  }

  const handleUpdate = async() => {
    let data = form.getFieldsValue();
    data['name'] = name;
    data['seo'] = name.replace(/ /g, '-').toLowerCase();
    update(jobPosition.seo, data, success);
    // console.log(data)
  }

  useEffect(() => {
    EventEmitter.subscribe('job_position_response', data => {
      navigate('/employee-app/job-positions/'+data);
    });
    return () => EventEmitter.unsubscribe('job_position_response');
  },[]);

  return (
    <div className='container mx-auto' style={{maxWidth: '900px'}}>
      <div>
        <div className='flex'>
          <h3 className='font-bold'>
            <Link to={'/employee-app/job-positions'} className='whitespace-nowrap hover:underline text-sky-600 dark:text-white'>Job Positions</Link> / {params.action}
          </h3>
          <Tooltip title={'save manually'} placement='rightBottom' className='ms-1'>
            <Button onClick={handleSubmit} type='text' htmlType='button'
              disabled={ jobPosition.name ? true : false}
              className='border-0 bg-transparent focus:bg-transparent'
              icon={<FaCloudArrowUp />}
            />
          </Tooltip>
        </div>
        {jobPosition.name && <Button onClick={handleUpdate}>UPDATE</Button>}
      </div>
      <div className='mt-5 bg-white p-3'>
        <FloatingLabel 
          className='text-2xl' 
          variant="standard" 
          label="Name" 
          value={name} 
          onChange={onChangeName}
          style={{maxWidth: '500px'}}
        />
        <Form 
          form={form}
          labelAlign='left'
          labelCol={{span: 5}}
          initialValues={jobPosition.seo ? jobPosition :
            {active: true, color: "#1677ff"}}
          variant='borderless'
        >
          <Tabs 
            items={[
              {
                key: '1',
                label: 'Description',
                children: 
                <Form.Item name={'descriptions'} className='font-semibold text-gray-800 mb-1' required>
                  <Input type='text' placeholder='job description' className='font-normal input-outline-none' />
                </Form.Item>
              }
            ]}
          />
        </Form>
      </div>
    </div>
  )
}
export default JobPositionChanges;